import { render, staticRenderFns } from "./StackedBarChart.vue?vue&type=template&id=8da9e1ae&scoped=true"
import script from "./StackedBarChart.vue?vue&type=script&lang=js"
export * from "./StackedBarChart.vue?vue&type=script&lang=js"
import style0 from "./StackedBarChart.vue?vue&type=style&index=0&id=8da9e1ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da9e1ae",
  null
  
)

export default component.exports